// Safe localStorage helpers for game progress
export const loadSave = (name) => {
  try {
    return JSON.parse(localStorage.getItem(name));
  } catch (e) {
    return null;
  }
};

export const storeSave = (name, value) => {
  try {
    localStorage.setItem(name, JSON.stringify(value));
  } catch (e) {
    // storage unavailable
  }
};
